import { Getter } from 'vuex'
import { RootState } from '@/store/types'

const getPlatform: Getter<RootState, RootState> = (state: RootState) => {
  return state.platform
}

export default getPlatform
